<template>
  <div class="crypto-first-step">
    <!-- <p class="pt-2 mx-2 choose-currency">{{ $t("unauth-payment.choose-currency") }} </p> -->
    <div class="search-wrapper ml-1 pt-2 w-100 d-flex flex-row justify-content-between align-items-center">
      <input ref="searchInput" type="text" v-model="searchData" class="search-input ml-n1"
        placeholder="Search currencies" />
      <span v-if="searchData !== ''" class="clear-data" @click="clearSearchData">
        <img src="@/assets/img/close.svg" />
      </span>
    </div>
    <div class="currencies-list mt-1">
      <div
        class="cursor-pointer d-flex flex-row justify-content-between w-100 align-items-start border-bottom currency-option"
        v-for="(wallet, i) in walletOptions" :key="i" @click="exchangeCoinChange(wallet)">
        <div class="d-flex flex-row align-items-start">
          <div>
            <img :src="wallet.logo" :alt="wallet.currency" class="currency-icon" :id="'currency-icon' + i" />
            <b-tooltip :target="'currency-icon' + i" placement="top" class="my-tooltip-class text-capitalize">
              <span class="text-capitalize">Network: {{ wallet.chainsNetworkFullTitle }}</span>
            </b-tooltip>
          </div>
          <small class="mt-1 ml-2">
            {{ wallet.name }} ({{
              wallet.currency.toUpperCase() === "USDT"
              ? "USDT(ERC20)"
              : wallet.currency
            }})</small>
          <div v-if="wallet && wallet.fasterConfirmation" class="lightning-icon">
            <img src="@/assets/img/lightning.svg" alt="" />
          </div>
        </div>
        <!-- {{ wallet.chainsNetworkLogo }} -->
        <div class="text-capitalize mr-3 text-muted w-25" v-if="wallet && wallet.chainNetwork">
          <!-- <small> <img
            :src="wallet.chainsNetworkLogo"
            :alt="wallet.currency"
            class="currency-icon"
            :id="'chainNetwork'+i"
          />
         <b-tooltip
          :target="'chainNetwork'+i"
           placement="top"
          class="my-tooltip-class text-capitalize "
        >
         <span class="text-capitalize">Network: {{wallet.chainNetwork}}</span>
        </b-tooltip>
        </small> -->
        </div>
      </div>
    </div>
    <div v-b-tooltip.hover.top="{ customClass: 'my-tooltip-class' }" :title="$t('payment.faster-tooltip')"
      class="d-flex flex-row cursor-pointer faster-payment mt-3">
      <img class="logo" src="@/assets/img/lightning.svg" alt="" />
      <div class="font-weight-400 mt-1 mr-2">Faster Payments</div>
      <!-- <img class="logo" src="@/assets/img/lightning.svg" alt=""/> -->
      <img class="logo-i" src="@/assets/img/info_blue.svg" />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import _ from "lodash";
import { USER_TRACK_EVENTS } from "@/store/modules/user/consts";

export default {
  name: "FirstStep",
  props: {
    walletOptions: Array,
  },
  watch: {
    searchData: _.debounce(function (val) {
      this.$emit("searchData", val);
    }, 500),
  },
  data() {
    return {
      searchData: "",
    };
  },
  methods: {
    async clearSearchData() {
      this.searchData = "";
    },
    exchangeCoinChange(wallet) {
      this.$emit(`exchangeCoinChange`, wallet);

      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "Crypto wallet tab",
          activity: `selected cryptocurrency`,
          meta: {
            currency: wallet.name
          }
        },
      });
    },
  },
};
</script>
<style lang="scss">
.crypto-first-step {
  .search-input {
    width: 100%;
    border: none;
    border-bottom: 1px solid #ededee;
    padding: 5px;
    font-size: 14px;
    color: #1b1f3b;
    outline: none;

    &::placeholder {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45) !important;
    }
  }

  .progress-bar {
    background-color: purple;
  }

  .faster-payment {
    float: right;
  }

  .choose-currency {
    font-size: 14px;
  }

  .currencies-list {
    max-height: 250px;
    overflow-y: auto;
  }
}

.currency-icon {
  width: 35px;
  height: 35px;
  padding: 5px;
}

.clear-data {
  cursor: pointer;

  img {
    width: 15px;
  }
}
</style>
